export const BULK_PRICING_SERVICE_TYPES = [21, 24, 26, 25, 27, 29];

export const SERVICE_TYPE_TO_LOCATION_KEY = {
  21: 'self_service_washing',
  24: 'vacuum_cleaner',
  26: 'windshield_washer_liquid_dispenser',
  25: 'paper_towel_dispenser',
  27: 'car_mat_cleaner',
  29: 'tyre_blackener',
};

export const SELF_SERVICE_MODES = [
  { id: 'soaking', label: 'Atmirkymas', optionType: 101 },
  { id: 'washing', label: 'Plovimas', optionType: 102 },
  { id: 'rinsing', label: 'Skalavimas', optionType: 103 },
  { id: 'waxing', label: 'Vaškavimas', optionType: 104 },
  { id: 'drying', label: 'Sausinimas', optionType: 105 },
];

export const VACUUM_INTERVALS = [
  { id: 'regular', label: '3 min', optionType: 301 },
  { id: 'mid', label: '6 min', optionType: 302 },
  { id: 'max', label: '9 min', optionType: 303 },
];

export const createEmptyBulkForm = serviceType => {
  switch (serviceType) {
    case 21:
      return SELF_SERVICE_MODES.reduce(
        (acc, { id }) => ({
          ...acc,
          [`${id}Price`]: '',
          [`${id}Duration`]: '',
        }),
        {}
      );
    case 24:
      return VACUUM_INTERVALS.reduce(
        (acc, { id }) => ({
          ...acc,
          [`${id}Price`]: '',
        }),
        {}
      );
    case 26:
      return {
        summerPrice: '',
        summerMonth: '',
        winterPrice: '',
        winterMonth: '',
      };
    case 25:
      return { price: '' };
    case 27:
      return { price: '', duration: '' };
    case 29:
      return { price: '', duration: '' };
    default:
      return {};
  }
};

export const createEmptyTouched = serviceType => {
  const form = createEmptyBulkForm(serviceType);
  return Object.keys(form).reduce((acc, key) => ({ ...acc, [key]: false }), {});
};
